'use client';

import { ReactNode } from 'react';
import { MotionFigure } from '../diagrams/_motion';

export function ScrollReveal({
  children,
  className,
  delay,
}: {
  children: ReactNode;
  className?: string;
  delay?: number;
}) {
  return (
    <MotionFigure className={className}>
      <div className="academy-stagger" style={{ transitionDelay: `${delay ?? 0}s` }}>
        {children}
      </div>
    </MotionFigure>
  );
}
